// @flow
import _ from 'lodash'
import type { State } from './reducers'
import type { AudienceNameParts, AudienceNameTemplate } from '../../../components/types'
import getAudienceNameParts from './getAudienceNameParts'
import { transliterate } from 'transliteration'

export default function collectAudienceName(state: State, segmentation: Object): string {
  const { audienceNameTemplates, selectedAudienceNameTemplateId } = state

  const audienceNameTemplate = _.find(audienceNameTemplates, (template) => {
    return template.id === selectedAudienceNameTemplateId
  })
  const language = (audienceNameTemplate && audienceNameTemplate.language) || 'RU'
  const audienceNameParts = getAudienceNameParts(state, segmentation, language)

  if (selectedAudienceNameTemplateId === null)
    return defaultAudienceNameFromParts(audienceNameParts)

  if (audienceNameTemplate && audienceNameTemplate.value) {
    const name = _.reduce(
      audienceNameParts,
      (name, value, variable) => {
        return name.replace(`{${variable}}`, value)
      },
      audienceNameTemplate.value
    )
    return cleanName(name, audienceNameTemplate)
  } else {
    return defaultAudienceNameFromParts(audienceNameParts)
  }
}

function defaultAudienceNameFromParts(audienceNameParts: AudienceNameParts) {
  return _.join(_.reject(_.values(audienceNameParts), _.isEmpty), '/')
}

function cleanName(name: string, audienceNameTemplate: AudienceNameTemplate) {
  const translatedName = audienceNameTemplate.language === 'RU' ? name : transliterate(name)
  return translatedName
    .replace(/\s/g, '-')
    .replace(/([_/-]){2,}/g, '$1')
    .replace(/^[_/-]/, '')
    .replace(/[_/-]$/, '')
}
